module.exports = __webpack_public_path__ + "static/mouse-outline-f6948a7b2c95301451398370e6274878.png";